export const normalizarTagParceiro = (tag: string) => tag.trim().toUpperCase();

export const tagParceiroValida = (tag: string) =>
  /^[A-Z][A-Z0-9]{0,9}$/.test(normalizarTagParceiro(tag));

export type EstadoDisponibilidadeTag =
  | "invalida"
  | "atual"
  | "publico"
  | "consultando"
  | "disponivel"
  | "ocupada"
  | "erro";

export async function consultarDisponibilidadeTagParceiro({
  tag,
  token,
  empresaId,
  signal,
}: {
  tag: string;
  token: string;
  empresaId?: string;
  signal?: AbortSignal;
}): Promise<{ disponivel: boolean; tagNormalizada: string }> {
  const params = new URLSearchParams({ tag: normalizarTagParceiro(tag) });
  if (empresaId) params.set("empresaId", empresaId);
  const response = await fetch(
    `/api/empresas/tag-parceiro-disponivel?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` }, signal },
  );
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.message || "Não foi possível verificar a TAG agora.");
  }
  if (typeof body.disponivel !== "boolean" || typeof body.tagNormalizada !== "string") {
    throw new Error("A resposta de disponibilidade da TAG é inválida.");
  }
  return body;
}
